module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sl_explainer":"To continue watching sample movies, <br>you need to sign up for a free membership.","sl_btn_join_free":"Free Sign Up","sl_btn_join_site":"Sign Up for 1pondo"},"ja":{"sl_explainer":"引き続きサンプル動画を視聴いただくには<br>無料会員登録が必要です。","sl_btn_join_free":"無料会員登録","sl_btn_join_site":"一本道への入会はこちら"}}')
  delete Component.options._Ctor
}
